import { render, staticRenderFns } from "./BadgeItem.vue?vue&type=template&id=c13a2dc4"
import script from "./BadgeItem.vue?vue&type=script&lang=ts"
export * from "./BadgeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports